"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Class KYBServiceManagement contain function to query and and create services
 * @public
 */
class KYBServiceManagement extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Function to get list KYB service
     * @param filter - filter by name or clientId. Eg: {name:'dev',clientId:'dev}
     * @param sort - field and order to sort. Eg: {name: 'asc',createdAt:'asc'}
     * @param page - page number
     * @param limit - limit number
     * @returns Return list KYB service data
     */
    async getListKYBService(filter = {}, sort, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.kybServiceManagementAPI.getListKYBService(filter, sort, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to create new service
     * @param {string} name service name
     * @param {string} clientId service client Id
     * @param {string} logo service logo link
     * @param {string} thumbnail service thumbnail link
     * @param {string} supportEmail service support email
     * @param {boolean} isFirstService it is first service of merchant or not
     * @returns
     */
    async createKYBService(name, clientId, logo, thumbnail, supportEmail, isFirstService) {
        try {
            const result = await this._apiV2.kybServiceManagementAPI.createKYBService(name, clientId, logo, thumbnail, supportEmail, isFirstService);
            return result;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update KYB service
     * @param {string} serviceId - Service Id
     * @param {UpdateKYBServicePayload} updateParams - All update params
     * @returns empty response
     */
    async updateKYBService(serviceId, updateParams) {
        try {
            const result = await this._apiV2.kybServiceManagementAPI.updateKYBService(serviceId, updateParams);
            return result;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get kyb service detail
     * @param {string} serviceId - Company Id
     * @returns Return kyb service detail
     */
    async getKYBServiceDetail(serviceId) {
        try {
            const result = await this._apiV2.kybServiceManagementAPI.getKYBServiceDetail(serviceId);
            return result;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     *Function to update live status of KYB service
     * @param {string} serviceId - Service Id
     * @param {boolean} isLive - Service Live status
     * @returns empty response
     */
    async updateKYBServiceLiveStatus(serviceId, isLive) {
        try {
            const result = await this._apiV2.kybServiceManagementAPI.updateKYBLiveStatus(serviceId, isLive);
            return result;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update Blockpass's access in KYB service
     * @param {string} serviceId - Service Id
     * @param {boolean} allowBlockpassAccess - Allow Blockpass's access in service or not
     * @returns
     */
    async allowBlockpassAccess(serviceId, allowBlockpassAccess) {
        try {
            const result = await this._apiV2.kybServiceManagementAPI.allowBlockpassAccess(serviceId, allowBlockpassAccess);
            return result;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = KYBServiceManagement;
